<form [formGroup]="parentForm">
  <mat-form-field>
    <mat-select
      [(ngModel)]="buildingSide"
      [formControlName]="'side'"
      placeholder="{{'HOME_CAROUSEL.SIDE' | translate}}">
      <mat-option *ngFor="let side of sides" [value]="side">
        {{side}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</form>
